define('modules/auth/forms/views/auth.view',[
    'client',
    'jquery',
    'bootstrap',
    'underscore',
    'backbone',
    'modules/base/models/token.model',
    'text!modules/auth/forms/templates/auth.template.html'
], function(
    Prospector,
    $,Bootstrap,_,Backbone,
    CredentialsModel,
    LoginTemplate
    ){
    var LoginView = Backbone.View.extend({
        template:_.template(LoginTemplate),
        className: 'loginView container-fluid unAuthView',
        events:function() {
            var base = {
                'keyup #userEmail'      : 'procKeyUp',
                'blur #userEmail'       : 'clearMessages',
                'focus #userEmail'      : 'clearMessages',
            };
            var click = {
                    'click .btn'           : 'procAuth',
                };
            $.extend(base,click);
            return base;
        },
        setURLError :"Login credentials incorrect",
        initialize: function() {
            this.debugName = 'login controller';
            window.auth = new CredentialsModel();
        },
        render: function() {
            $(this.el).html(this.template());
            return this;
        },
        procKeyUp: function(event) {
            var keypressed = event.keyCode || event.which;
            if (window.utils.validation.isCapsKey(event)) {
                this.$('.loadingMsg').html('E-mail address is case sensitive. Did you mean to enter upper case or have CAPS LOCK enabled?');
            } else if (keypressed == 13) {
                this.procAuth();
            }
        },
        clearMessages: function() {
            this.$('.loadingMsg').html('');
        },
        procAuth: function() {
            window.utils.blurForm();
            this.$('.loadingMsg').html('');
            window.auth.set(
                {
                    userName      : this.$('#userEmail').val().trim(),
                }
            );
            window.auth.once('sync', this.procResponse,this);
            window.auth.save();
        },
        procResponse: function() {
            if(window.auth.has('error')){
                    this.$('.loadingMsg').html("Error: " + window.auth.get('error').message);
                    window.auth.set({error: undefined});
            }else {
                window.utils.createCookie("specifiedHost", window.auth.get('name'));
                window.utils.createCookie("userName", window.auth.get('userName'));
                Prospector.navigate('auth', true)
            }
        }
    });
    return LoginView;
});


